module.exports = __webpack_public_path__ + "img/amy_logo.279fc387.png";